var _g, _g2, _defs, _sodipodiNamedview, _metadata;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackwards(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    width: "64px",
    height: "64px",
    viewBox: "0 0 30 30",
    id: "svg822",
    inkscapeVersion: "0.92.4 (f8dce91, 2019-08-02)",
    sodipodiDocname: "skip-back.svg",
    fill: "#969696",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs816"
  })), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "base",
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    inkscapePageopacity: 0,
    inkscapePageshadow: 2,
    inkscapeZoom: 17.833333,
    inkscapeCx: 15,
    inkscapeCy: 15,
    "inkscapeDocument-units": "px",
    "inkscapeCurrent-layer": "layer1",
    showgrid: "true",
    units: "px",
    "inkscapeWindow-width": 1366,
    "inkscapeWindow-height": 713,
    "inkscapeWindow-x": 0,
    "inkscapeWindow-y": 0,
    "inkscapeWindow-maximized": 1,
    inkscapeLockguides: "true"
  }, /*#__PURE__*/React.createElement("inkscapeGrid", {
    type: "xygrid",
    id: "grid816"
  }))), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata819"
  }, /*#__PURE__*/React.createElement("rdfRdf", null, /*#__PURE__*/React.createElement("ccWork", {
    rdfAbout: ""
  }, /*#__PURE__*/React.createElement("dcFormat", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dcType", {
    rdfTesource: "http://purl.org/dc/dcmitype/StillImage"
  }), /*#__PURE__*/React.createElement("dcTitle", null))))), /*#__PURE__*/React.createElement("g", {
    inkscapeLabel: "Layer 1",
    inkscapeGroupmode: "layer",
    id: "layer1",
    transform: "translate(0,-289.0625)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#969696",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 4,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 8.0429688 7 L 8.0429688 23 L 10.042969 23 L 10.042969 7 L 8.0429688 7 z M 21.957031 7 L 12.896484 13.216797 C 11.84261 13.939957 11.894918 15.276052 12.896484 16.044922 L 21.957031 23 L 21.957031 7 z ",
    transform: "translate(0,289.0625)",
    id: "rect814"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackwards);
export default __webpack_public_path__ + "static/media/backwards.13cafc2fdeacef729eb38c3b19d2bcd2.svg";
export { ForwardRef as ReactComponent };